export const CONTENT_LIMITS = Object.freeze({
  lessonBody: 40000,
  noteBody: 500,
  flashcardQuestion: 120,
  flashcardAnswer: 180,
  totalBodyPerUser: 180000,
  maxOwnedCommunities: 1,
  connectionNoteBody: 250,
  connectionDailyNotes: 2,
  acceptedConnectionDailyNotes: 4,
  connectionThreadNotes: 20,
  connectionThreads: 20,
  connectionUnreadThreads: 10,
});

export const OWNER_UNLIMITED_EMAIL = "constantin.tararache@proton.me";

export const EARLY_ACCESS_LIMITS = Object.freeze({
  lessonBody: 200000,
  noteBody: 500,
  flashcardQuestion: 120,
  flashcardAnswer: 180,
  totalBodyPerUser: 2000000,
  maxOwnedCommunities: 10,
  connectionNoteBody: 500,
  connectionDailyNotes: 5,
  acceptedConnectionDailyNotes: 10,
  connectionThreadNotes: 500,
  connectionThreads: 500,
  connectionUnreadThreads: 25,
});

export const TIERS = Object.freeze({
  FREE: "free",
  EARLY_ACCESS: "early_access",
});

export const LIMITS_PROFILES = Object.freeze({
  FREE: "free",
  UNLIMITED: "unlimited",
});

export const normalizeEmail = (email = "") => String(email).trim().toLowerCase();

export const isUnlimitedUser = (user) =>
  normalizeEmail(user?.email) === OWNER_UNLIMITED_EMAIL ||
  (user?.limitsProfile || LIMITS_PROFILES.FREE) === LIMITS_PROFILES.UNLIMITED;

export const getEffectiveLimits = (user) => {
  if (isUnlimitedUser(user)) return null;
  if ((user?.tier || TIERS.FREE) === TIERS.EARLY_ACCESS) return EARLY_ACCESS_LIMITS;
  return CONTENT_LIMITS;
};

export const getPlanLimits = (user) => {
  if ((user?.tier || TIERS.FREE) === TIERS.EARLY_ACCESS) {
    return EARLY_ACCESS_LIMITS;
  }

  return CONTENT_LIMITS;
};

export const getConnectionLimits = (user) =>
  isUnlimitedUser(user) ? EARLY_ACCESS_LIMITS : getPlanLimits(user);

export const getOwnedCommunityLimit = (user) =>
  isUnlimitedUser(user) ? Infinity : getPlanLimits(user).maxOwnedCommunities;

export const getBodyLimitByContentType = (contentType, user) => {
  const limits = getEffectiveLimits(user);
  if (!limits) return null;
  if (contentType === "note") return limits.noteBody;
  if (contentType === "flashcard") return limits.flashcardAnswer;
  return limits.lessonBody;
};

export const getEffectiveBodyLimit = (contentType, user) =>
  isUnlimitedUser(user) ? null : getBodyLimitByContentType(contentType, user);

export const isEarlyAccess = (user) =>
  (user?.tier || TIERS.FREE) === TIERS.EARLY_ACCESS;

export const canUsePdfImport = (user) =>
  isUnlimitedUser(user) || isEarlyAccess(user);
